import { useAuth } from '../../hooks/useAuth';
import { LogOut, User, Menu } from 'lucide-react';

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <header className="flex h-16 items-center justify-between border-b border-gray-100 bg-white px-4 lg:px-6">
      <button
        onClick={onMenuClick}
        className="rounded p-2 text-gray-500 hover:bg-gray-100 lg:hidden"
      >
        <Menu size={20} />
      </button>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-100 text-brand-600">
            <User size={16} />
          </div>
          <span className="hidden font-medium sm:inline">{user?.name}</span>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1 rounded-lg px-3 py-1.5 text-sm text-gray-500 hover:bg-gray-100 hover:text-red-600"
        >
          <LogOut size={16} />
          <span className="hidden sm:inline">Выйти</span>
        </button>
      </div>
    </header>
  );
}
